import React, { Component } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'

// Components
import LoginSection from './login/LoginSection'
import DeliverySection from './delivery/DeliverySection'
import ShippingSection from './shipping/ShippingSection'
import BillingSection from './billing/BillingSection'
import OrderReviewSection from './order-review/OrderReviewSection'
import PaymentSection from './payment/PaymentSection'

// State
import { setActiveCheckoutSection } from '../../store/actions/checkout'

// Util
const {
	checkoutSignIn: checkoutSignInGA,
	setCheckoutSectionActive: setCheckoutSectionActiveGA,
} = require('../../utils/google-analytics')
class CheckoutMain extends Component {
	constructor(props) {
		super(props)
		this.state = {
			activeSection: {},
		}
	}

	componentDidMount() {
		this.setActiveSection(this.props)
	}

	componentWillReceiveProps(newProps) {
		// console.log('componentWillReceiveProps:', newProps)
		this.setActiveSection(newProps)
	}

	setActiveSection = props => {
		let sectionNum = 1

		// console.log('setActiveSection')

		// If user is not logged in
		if (!props.user) {
			this.props.setActiveCheckoutSection('login')
			this.setState({
				activeSection: {
					name: props.activeSection,
					number: sectionNum,
				},
			})
			return
		} else {
			checkoutSignInGA(this.props.items)
		}

		// If no section is active, section 2 will be the starting point
		if (!props.activeSection || props.activeSection === 'login') {
			this.props.setActiveCheckoutSection('delivery')
		}

		// We will set a section number so we can figure out exactly where we are in the process and decide which sections to show
		if (props.activeSection === 'delivery') {
			setCheckoutSectionActiveGA(2)
			sectionNum = 2
		} else if (props.activeSection === 'shipping') {
			setCheckoutSectionActiveGA(3)
			sectionNum = 3
		} else if (props.activeSection === 'billing') {
			setCheckoutSectionActiveGA(4)
			sectionNum = 4
		} else if (props.activeSection === 'order') {
			setCheckoutSectionActiveGA(5)
			sectionNum = 5
		} else if (props.activeSection === 'payment') {
			setCheckoutSectionActiveGA(6)
			sectionNum = 6
		}

		// console.log('setActiveSection:', props.activeSection)

		this.setState({
			activeSection: {
				name: props.activeSection,
				number: sectionNum,
			},
		})
	}

	render() {
		const { user } = this.props
		const { activeSection } = this.props
		const activeSectionNum = this.state.activeSection.number

		// console.log('checkoutmain render')

		return (
			<div className='checkout-section section--large'>
				{/* LOGIN */}
				<div className={'section checkout-step' + (user ? ' completed--not-clickable' : '')}>
					<LoginSection />
				</div>

				{/* DELIVERY */}
				<div
					className={
						'section checkout-step' +
						(activeSectionNum < 2 ? ' inactive' : '') +
						(activeSectionNum > 2 ? ' completed' : '')
					}
					onClick={() => {
						if (activeSectionNum > 2) this.props.setActiveCheckoutSection('delivery')
					}}
				>
					<div className='section-heading section--large-heading'>
						<span className='txt'>2</span>
						<span className='content'>Delivery Options</span>
					</div>
					<div className='section-content'>
						{activeSection === 'delivery' && <DeliverySection />}
					</div>
				</div>

				{/* SHIPPING */}
				<div
					className={
						'section checkout-step' +
						(activeSectionNum < 3 ? ' inactive' : '') +
						(activeSectionNum > 3 ? ' completed' : '')
					}
					onClick={() => {
						if (activeSectionNum > 3) this.props.setActiveCheckoutSection('shipping')
					}}
				>
					<div className='section-heading section--large-heading'>
						<span className='txt'>3</span>
						<span className='content'>Shipping</span>
					</div>
					<div className='section-content'>
						{activeSection === 'shipping' && <ShippingSection />}
					</div>
				</div>

				{/* BILLING */}
				<div
					className={
						'section checkout-step' +
						(activeSectionNum < 4 ? ' inactive' : '') +
						(activeSectionNum > 4 ? ' completed' : '')
					}
					onClick={() => {
						if (activeSectionNum > 4) this.props.setActiveCheckoutSection('billing')
					}}
				>
					<div className='section-heading section--large-heading'>
						<span className='txt'>4</span>
						<span className='content'>Billing</span>
					</div>
					<div className='section-content'>{activeSection === 'billing' && <BillingSection />}</div>
				</div>

				{/* ORDER */}
				<div
					className={
						'section checkout-step' +
						(activeSectionNum < 5 ? ' inactive' : '') +
						(activeSectionNum > 5 ? ' completed' : '')
					}
					onClick={() => {
						if (activeSectionNum > 5) this.props.setActiveCheckoutSection('order')
					}}
				>
					<div className='section-heading section--large-heading'>
						<span className='txt'>5</span>
						<span className='content'>Order</span>
					</div>
					<div className='section-content'>
						{activeSection === 'order' && <OrderReviewSection />}
					</div>
				</div>

				{/* PAYMENT */}
				<div className={'section checkout-step' + (activeSectionNum < 6 ? ' inactive' : '')}>
					<div className='section-heading section--large-heading'>
						<span className='txt'>6</span>
						<span className='content'>Payment</span>
					</div>
					<div className='section-content'>{activeSection === 'payment' && <PaymentSection />}</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		user: !!state.user.customer || !!state.user.guest,
		activeSection: state.checkout.activeSection,
		delivery: !isEmpty(state.checkout.delivery),
		shipping: !isEmpty(state.checkout.shipping),
		billing: !isEmpty(state.checkout.billing),
		order: state.checkout.order,
		payment: !isEmpty(state.checkout.payment),
		items: state.cart.items,
	}
}

export default connect(mapStateToProps, { setActiveCheckoutSection })(CheckoutMain)



// WEBPACK FOOTER //
// ./src/components/checkout/CheckoutMain.js